import axios from 'axios'
// import store from '@/store'

// const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjUzMzUyMjkwLCJleHAiOjE2NTU5NDQyOTB9.tdOasjNvNjUuRoCklsA-s_1DG1eWFpCpKA2YyZ5OLCU'
// const token = localStorage.getItem('token') || ''

export default () =>
  axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'https://backend.der-lagermeister.de',
    // baseURL: 'http://localhost:1338',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
